export default {
  NO_ASINID: 'No Product ID!',
  LOGIN_INFORMATION_IS_INCORRECT_PLEASE_LOG_IN_AGAIN:
    'Login Information Error  Please Log in Again!',
  API_ERRPR: 'Interface Error!',
  YUAN_EXCLUSIVE_FOR_NEW_CUSTOMER: 'Yuan [New User Exclusive]',
  COUPON_EXCLUSIVE_FOR_NEW_CUSTOMER: 'Coupon [New User Exclusive]',
  FREE_SHIPPING: 'Free Shipping',
  FREE_SHIPPING_EXCLUSIVE_FOR_NEW_CUSTOMER:
    'Free Shipping [New User Exclusive]',
  NEW_CUSTOMER_COUPONS: 'New User Coupon',
  PAY_NOW: 'Pay now',
  NO_MORE: 'No more',
  REQUEST_FAILED_CLICK_TO_RELOAD: 'Request Failed  Click to Reload',
  PURCHASE: 'Purchase',
  ALL_C_REVIEW: 'All Reviews',
  JUMP_TO_SEARCH_PAGE: 'Jump to Search Page',
  SEARCH: 'Search',
  COMPREHENSIVE_SORTING: 'Comprehensive Sorting',
  PRICE: 'Price',
  AMAZON_GLOBAL_BRAND_STORE: 'Amazon Global Store Brand Store',
  COUPONS: 'Coupons',
  TERMS_AND_CONDITION: 'Terms',
  ALL_CATEGORY_BENEFITS_FOR_FULL_SELECTION:
    'Benefits for All Products and Categories',
  AVAILABEL_PRODUCTS: 'Available Products',
  CLAIMNOW: 'Claim Now',
  CURRENTLY_NO_COUPONS_AVAILABLE: 'No Coupon Available',
  I_SEE: 'I Understand',
  FULL: 'Full',
  BOT_AVAILABLE: 'No Available',
  CLAIMED_SUCCESSFULLY: 'Claimed successfully',
  BEST_SELLING_ITEM_RECOMMENDATION: 'Bestselling Product Recommendations',
  C_REVIEW: 'Customer reviews',
  NO_C_REVIEW_CURRENTLY_AVAILABLE: 'No customer reviews',
  VIEW_ALL: 'View all',
  AMAZON_PURCHASER: 'Amazon Buyers',
  ADD_YOUER_C_REVIEW: 'Add Your Review',
  AFTER_THE_COUPON_DISCOUNT: 'After coupon',
  AFTER: 'After',
  COUPON: 'Coupon',
  SAVE: 'Save',
  CLAIM_THE_COUPON: 'Claim Coupon',
  SEARCH_FOR_MORE_GLOBAL_STORE_PRODUCTS: 'Search More Global Store Products',
  PRODUCT: 'Product',
  DETAIL: 'Details',
  REVIEW: 'Reviews',
  RECOMMEND: 'Recommendations',
  OTHER_SELLERS_SELLING_THE_SAME_PRODUCT: 'Other Sellers of the Same Product',
  SELECTED: 'Selected',
  SHIPPING: 'Shipping',
  AMAZON: 'Amazon',
  SOLD_BY: 'Sold by Amazon US',
  SOLD_AND_SHIPPED: 'Sold by and ships from Amazon US',
  EXPRESS_DELIVERY: 'Express',
  FREIGHT_IS_SUBJECT_TO_ACTUAL_SETTLEMENT:
    'The actual shipping fee is subject to settlement',
  SEND_TO: 'Deliver to',
  GLOBAL_STORE_DIRECT_SHIPPING_PACKAGES_USUALLY_TAKE_4_12_DAYS_TO_DELIVER:
    '4-12 days for international delivery',
  PLEASE_SELECT_THE_ADDRESS: 'Please add a delivery address.',
  CSF: 'Import fee',
  ESTIMATE: 'Estimated ',
  IFD_IS_SUBJECT_TO_ACTUAL_SETTLEMENT:
    'Actual taxes and fees will be finalized upon settlement.',
  NOT_SUPPORT_30_DAY_RETURN_WITHOUT_AREASON: 'Ineligible for return',
  AMAZON_GLOBAL_STORE: 'Amazon  Global Stores Purchase',
  SALES_AND_SHIPPING: 'Sell and ship',
  PRODUCT_DETAIL: 'Product details',
  PRODUCT_FEATURES_BASIC_INFORMATION: 'Product Features & Basic Information',
  AMAZON_GLOBAL_STORE_TIPS: 'Tips for Amazon Global Stores purchase',
  GATEWAY: 'Home',
  CART: 'Cart',
  ALREADY: 'Already',
  COLLECT: 'Save',
  ADD_TO_CART: 'Add to Cart',
  PURCHASE_CLAIM_THE_COUPON: 'After coupon',
  PURCHASE_IMMEDIATELY: 'Buy Now',
  COLLECT_SUCCESSFULLY: 'Successfully Moved In',
  COLLECT_FAILED: 'Failed to Move In',
  THE_CURRENT_ASIN_IS_TEMPORARILY_OUT_OF_STOCK:
    'Item is currently out of stock',
  VIEW_OTHER_ASINS: 'View other items',
  JUMP_TO: 'Jump to',
  CONTINUE_SLIDING_TO_VIEW_C_REVIEWS: 'Slide more to view customer reviews',
  TOTAL: 'Total',
  SORT: 'types',
  CURRENTLY_OUT_OF_STOCK: 'Currently unavailable',
  RELEASE_SLIDE_TO_VIEW_C_REVIEWS: 'Release sliding to view customer reviews',
  DOTD_DISCOUNTED_PRICE: 'Deal price',
  TIME_REMAINING: 'Ends in ',
  DOTD: "Today's Deals",
  BEST_DEAL_PRICE: 'Best deal price',
  BEST_DEAL: 'Best deal',
  DAY: 'd',
  PRODUCT_INFO: 'Product information',
  SEARCH_FOR_MILLIONS_OF_PRODUCTS: 'Search millions of products',
  USUALLY_SHIPS_WITHIN_WEEKS: 'Usually ships in 4-6 weeks',
  UP: 'n/a',
  BUY_NOW_OR_MISS_OUT: 'Only {X} left in stock - order soon',
  PLEASE_BROWSE_OTHER_PRODUCTS: 'Go check out other items',
  ALL: 'All',
  AMAZON_BUYER: 'Amazon customer',
  GO_APP_VIEW: 'Go to the app to view',
  SIZE_CHART: 'Size Chart'
};
